import { Document } from "@react-pdf/renderer";

import { AnalysisReportPdfFooter } from "src/core/components/folders-list/pdf/AnalysisReportPdfFooter";
import { AnalysisReportSommaireSection } from "src/core/components/folders-list/pdf/sections/Sommaire";
import { AnalysisReportSynthesisSection } from "src/core/components/folders-list/pdf/sections/Synthesis";
import { AnalysisReportTableSection } from "src/core/components/folders-list/pdf/sections/Table";
import { CoverPage } from "src/core/components/pdf/shared/CoverPage";
import { PdfHeader } from "src/core/components/pdf/shared/PdfHeader";
import { PdfPage } from "src/core/components/pdf/shared/PdfPage";
import { User } from "src/core/gql/graphql";
import { ValidatedFoldersStatistics } from "src/core/hooks/folders-list/folder-risk-statistics/types";

type ValidatedFoldersPdfDocumentProps = {
  currentUser: User;
  statistics: ValidatedFoldersStatistics;
};

export const ValidatedFoldersPdfDocument = ({
  currentUser,
  statistics,
}: ValidatedFoldersPdfDocumentProps) => {
  return (
    <Document>
      {/* Page de garde */}
      <CoverPage titleTranslationKey={"pdf.validatedFolders.title"} />

      {/* Sommaire */}
      <PdfPage>
        <PdfHeader />
        <AnalysisReportSommaireSection />
        <AnalysisReportPdfFooter currentUser={currentUser} />
      </PdfPage>

      {/* Première page / récapitulatif */}
      <AnalysisReportSynthesisSection
        currentUser={currentUser}
        nbDossiers={statistics.nombreTotalDossiers}
        statistics={statistics}
      />

      {/* Syntèhses des traitements */}
      <AnalysisReportTableSection currentUser={currentUser} statistics={statistics} />
    </Document>
  );
};
